import React, { Fragment, useContext, useEffect, useState } from 'react';
import {
    Col,
    Dropdown,
    Form,
    Spinner,
    ProgressBar,
    Button,
    Card,
    InputGroup,
    ButtonGroup
} from "react-bootstrap";
import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import {
    fetchCurrentUserBooks,
    getFullBookDataUrlApi, // 🔹 добавлено: API-граббер
} from "../../http/bookAPI";
import Row from "react-bootstrap/Row";
import defaultImage from "../../assets/empty-cover.jpg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getRedirectUrlApi } from "../../http/userAPI";
import CacheUpdateModalBook from "../../helpers/CacheUpdateModalBook";
import { findReviewerPenNameConflict, ReviewerNameSafetyModal } from "../../helpers/ReviewerNameSafety";

const AddBookByGrabFromAmazon = observer(() => {
    const { book } = useContext(Context);
    const { user } = useContext(Context);

    const [titleState, setTitleState] = useState('');
    const [subtitleState, setSubTitleState] = useState('');
    const [authorState, setAuthorState] = useState('');
    const [summaryState, setSummaryState] = useState('');
    const [coverFileState, setCoverFileState] = useState(null);
    const [coverPreview, setCoverPreview] = useState(defaultImage);
    const [amzlinkState, setAmzlinkState] = useState(''); // 🔹 будет использовано на шаге 0
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [reviewerSafetyConflict, setReviewerSafetyConflict] = useState(null);
    const [description, setDescription] = useState("");

    const [kindlePriceState, setKindlePriceState] = useState('');
    const [paperbackPriceState, setPaperbackPriceState] = useState('');
    const [hardcoverPriceState, setHardcoverPriceState] = useState('');

    const [noManuscript, setNoManuscript] = useState(false);
    const [publicCatalogVisible, setPublicCatalogVisible] = useState(true);

    const [paperbackAsinState, setPaperBackAsinState] = useState('');
    const [kindleAsinState, setKindleAsinState] = useState('');
    const [hardcoverAsinState, setHardCoverAsinState] = useState('');
    const [audioAsinState, setAudioAsinState] = useState('');
    const [audibleAsinState, setAudibleAsinState] = useState('');
    const [audioBookLinkState, setAudioBookLinkState] = useState('');
    const [selectedWordCount, setSelectedWordCount] = useState({
        id: 1, count: 10000, label: "About 10,000"
    });

    const [territoriesMode, setTerritoriesMode] = useState("WORLDWIDE"); // WORLDWIDE | MARKETPLACES
    const [availableMarketplaces, setAvailableMarketplaces] = useState([]);
    const [showMarketplaces, setShowMarketplaces] = useState(false);


    const MARKETPLACE_OPTIONS = [
        { code: 'com', label: 'Amazon.com (US)' },
        { code: 'co.uk', label: 'Amazon.co.uk (UK)' },
        { code: 'ca', label: 'Amazon.ca (CA)' },

        { code: 'de', label: 'Amazon.de (DE)' },
        { code: 'fr', label: 'Amazon.fr (FR)' },
        { code: 'it', label: 'Amazon.it (IT)' },
        { code: 'es', label: 'Amazon.es (ES)' },

        { code: 'co.jp', label: 'Amazon.co.jp (JP)' },
        { code: 'com.au', label: 'Amazon.com.au (AU)' },
        { code: 'in', label: 'Amazon.in (IN)' },

        { code: 'com.mx', label: 'Amazon.com.mx (MX)' },
        { code: 'com.br', label: 'Amazon.com.br (BR)' },
    ];

    const getFirstAvailableAmazonAsin = () => (
        kindleAsinState ||
        paperbackAsinState ||
        hardcoverAsinState ||
        audioAsinState ||
        audibleAsinState ||
        ''
    ).trim().toUpperCase();

    const openMarketplaceAmazonLink = async (marketplaceCode, event) => {
        event?.preventDefault?.();
        event?.stopPropagation?.();

        const asin = getFirstAvailableAmazonAsin();
        if (!/^[A-Z0-9]{10}$/.test(asin)) {
            toast.info("Add at least one ASIN before opening Amazon.", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
            });
            return;
        }

        try {
            const response = await getRedirectUrlApi(`https://www.amazon.${marketplaceCode}/dp/${asin}`);
            if (response?.redirectUrl) {
                window.open(response.redirectUrl, "_blank", "noopener noreferrer");
            }
        } catch (error) {
            toast.error("Failed to open Amazon marketplace.", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
            });
        }
    };

    const renderMarketplaceLink = (m, text = m.label) => (
        <button
            type="button"
            className="btn btn-link btn-sm p-0 align-baseline text-decoration-none"
            onClick={(event) => openMarketplaceAmazonLink(m.code, event)}
        >
            {text}
        </button>
    );

    const [newBook, setNewdBook] = useState({
        message_flag: false,
        paper_back_flag: false,
        kindle_flag: true,
        kindle_unlimited_flag: false,
        hard_cover_flag: false,
        audio_flag: false,
        audio_exclusive_flag: false,
        audio_non_exclusive_flag: false,
        cover_file: null,
        summary: null,
        description_full: null,
        book_file: null,
        bp_asin: null,
        k_asin: null,
        hc_asin: null,
        audio_asin: null,
        book_temp_file: null,
    });

    const [step, setStep] = useState(0); // 0 — новый шаг: только поле с линком
    const [, setNextStep] = useState({
        step0: true,  // 🔹 теперь это "Insert link → Grab from Amazon"
        step1: false, // дальше всё как у тебя
        step2: false,
        step3: false,
        step4: false,
        step5: false,
        step6: false,
    });

    const wordCountOptions = [
        { id: 1, count: 1000, label: "About 1,000" },
        { id: 2, count: 5000, label: "About 5,000" },
        { id: 3, count: 10000, label: "About 10,000" },
        { id: 4, count: 15000, label: "About 15,000" },
        { id: 5, count: 20000, label: "About 20,000" },
        { id: 6, count: 25000, label: "About 25,000" },
        { id: 7, count: 30000, label: "About 30,000" },
        { id: 8, count: 35000, label: "About 35,000" },
        { id: 9, count: 40000, label: "About 40,000" },
        { id: 10, count: 45000, label: "About 45,000" },
        { id: 11, count: 50000, label: "About 50,000" },
        { id: 12, count: 60000, label: "About 60,000" },
        { id: 13, count: 75000, label: "About 75,000" },
        { id: 14, count: 85000, label: "About 85,000" },
        { id: 15, count: 100000, label: "About 100,000" },
        { id: 16, count: 120000, label: "More then 120,000" },
    ];

    // 📌 Соотношения сторон для разных форматов книг
    const [, setPdfFile] = useState(null)
    const [tempPDFFile, setTempPDFFile] = useState(''); // Для временного файла
    const [uploadProgress, setUploadProgress] = useState(0); // Для прогресса загрузки
    const [pdfFileTitle, setPdfFileTitle] = useState("")

    const [progress, setProgress] = useState(0);


    const hasStoredValue = (value) =>
        value !== undefined && value !== null && String(value).trim() !== "";

    const storedBool = (value, fallback = false) => {
        if (value === undefined || value === null || value === "") return fallback;
        if (typeof value === "boolean") return value;
        if (typeof value === "number") return value === 1;

        const normalized = String(value).trim().toLowerCase();
        if (["true", "1", "yes", "on"].includes(normalized)) return true;
        if (["false", "0", "no", "off"].includes(normalized)) return false;
        return fallback;
    };

    const getStoredBookTypes = (bookData = {}) => {
        const storedTypes = bookData.bookTypes || {};

        return {
            paper_back_flag: storedBool(
                storedTypes.paperBack ?? storedTypes.paper_back_flag ?? bookData.paper_back_flag ?? bookData.pb ?? bookData.paperBack,
                hasStoredValue(bookData.pb_asin || bookData.paper_back_asin)
            ),
            kindle_flag: storedBool(
                storedTypes.kindle ?? storedTypes.kindle_flag ?? bookData.kindle_flag ?? bookData.kindle,
                hasStoredValue(bookData.k_asin || bookData.kindle_asin)
            ),
            hard_cover_flag: storedBool(
                storedTypes.hardCover ?? storedTypes.hard_cover_flag ?? bookData.hard_cover_flag ?? bookData.hc ?? bookData.hardCover,
                hasStoredValue(bookData.hc_asin || bookData.hard_cover_asin)
            ),
            kindle_unlimited_flag: storedBool(
                storedTypes.kindle_u ?? storedTypes.kindleUnlimited ?? storedTypes.kindle_unlimited_flag ?? bookData.kindle_unlimited_flag ?? bookData.kindle_unlimited,
                false
            ),
            audio_flag: storedBool(
                storedTypes.audio ?? storedTypes.audio_flag ?? bookData.audio_flag ?? bookData.audio,
                hasStoredValue(bookData.audio_asin)
            ),
            audio_exclusive_flag: storedBool(
                storedTypes.audio_ex ?? storedTypes.audio_exclusive_flag ?? bookData.audio_exclusive_flag,
                false
            ),
            audio_non_exclusive_flag: storedBool(
                storedTypes.audio_non_ex ?? storedTypes.audio_non_exclusive_flag ?? bookData.audio_non_exclusive_flag,
                false
            ),
        };
    };


    // ---- utils: скачиваем картинку как File ----
    const fetchCoverDirect = async (url) => {
        // пробуем напрямую (может сработать, если CORS открыт)
        const resp = await fetch(url, { credentials: 'omit', mode: 'cors' });
        if (!resp.ok) throw new Error(`direct fetch failed: ${resp.status}`);
        const blob = await resp.blob();
        return { blob, contentType: blob.type || 'image/jpeg' };
    };

    const blobToFile = (blob, contentType, filenameHint = 'cover') => {
        const ext = (contentType.split('/')[1] || 'jpg').split(';')[0];
        return new File([blob], `${filenameHint}.${ext}`, { type: contentType });
    };

    const blobToBase64 = (blob) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });

    /**
     * Скачиваем картинку по URL -> кладём в состояния coverFileState + coverPreview.
     * Сначала прямой fetch, если не получится — через прокси.
     */
    const downloadAndSetCover = async (imageUrl, filenameHint = 'cover') => {
        if (!imageUrl) return;

        try {
            let got;
            try {
                got = await fetchCoverDirect(imageUrl);
            } catch {
             //   got = await fetchCoverViaProxy(imageUrl);
            }

            const file = blobToFile(got.blob, got.contentType, filenameHint);
            setCoverFileState(file);                       // для FormData
            const base64 = await blobToBase64(file);       // для превью/LS (как у тебя и было)
            setCoverPreview(base64);

            // сохраним в localStorage (совместимо с твоей логикой восстановления)
            saveBookDataToLocalStorage({
                cover_file: base64,
                cover_file_name: file.name,
            });

        } catch (err) {
            console.error('Cover download failed:', err);
            toast.warn('Could not download cover automatically. You can upload it manually.', { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    };

    // helper: форматируем число или пустую строку
    const safeVal = (v) => (typeof v === 'number' && Number.isFinite(v)) ? v.toFixed(2) : '';


    // ——— нормализация текста
    const norm = (s) => (s || "")
        .toString()
        .toLowerCase()
        .replace(/[^\p{L}\p{N}&+ ]/gu, " ")
        .replace(/\s+/g, " ")
        .trim();

// ——— подобрать язык из book.languages по строке с Амазона (например "English")
    const autoMatchLanguage = (langStr, languagesList) => {
        if (!langStr || !Array.isArray(languagesList) || !languagesList.length) return null;
        const n = norm(langStr);

        // 1) точное совпадение по полю language
        let hit = languagesList.find(l => norm(l.language) === n);
        if (hit) return hit;

        // 2) включение/частичное совпадение (например "English (US)")
        hit = languagesList.find(l => n.includes(norm(l.language)) || norm(l.language).includes(n));
        if (hit) return hit;

        // 3) простые синонимы → к нашим названиям
        const syn = {
            "portuguese (brazilian)": "Portuguese",
            "portuguese (european)": "Portuguese",
            "chinese (simplified)": "Chinese",
            "chinese (traditional)": "Chinese",
            "serbo-croatian": "Serbian",
        };
        const mapped = syn[n];
        if (mapped) {
            hit = languagesList.find(l => norm(l.language) === norm(mapped));
            if (hit) return hit;
        }

        return null;
    };

// ——— оценить кол-во слов по количеству печатных страниц и выбрать ближайший bucket
    const estimateWordCountBucket = (pages, buckets) => {
        const p = Number(pages) || 0;
        // типичный trade paperback 250–300 слов/страницу; берём 275 как “серединку”
        const words = Math.max(250, Math.round(p * 275));
        let best = buckets[0];
        let bestDiff = Math.abs(words - buckets[0].count);
        for (const b of buckets) {
            const d = Math.abs(words - b.count);
            if (d < bestDiff) { best = b; bestDiff = d; }
        }
        return best;
    };

// ——— подобрать жанр из book.genres по пути категорий/крошкам Amazon
    const autoPickGenre = (catsArr, catsPath, allGenres) => {
        if (!Array.isArray(allGenres) || !allGenres.length) return null;
        const hay = norm([...(catsArr || [])].join(" › ") + " " + (catsPath || ""));

        // 1) прямые попадания по строкам жанров из БД
        const directMatches = allGenres.filter(g => hay.includes(norm(g.genre)));
        if (directMatches.length) {
            // берём самый “специфичный” (длиннейшая строка)
            return directMatches.sort((a,b)=>b.genre.length - a.genre.length)[0];
        }

        // 2) словарь синонимов/маппингов Amazon → наш жанр
        const map = [
            ["young adult", "Young Adults & Children's"],
            ["children", "Young Adults & Children's"],
            ["teens", "Young Adults & Children's"],

            ["reference", "Reference & Law"],
            ["law", "Reference & Law"],

            ["christian", "Religion & Spirituality"],
            ["spirituality", "Religion & Spirituality"],

            ["cook", "Cookbooks, Food & Wine"],
            ["food & wine", "Cookbooks, Food & Wine"],

            ["home & garden", "Crafts, Hobbies & Home"],
            ["crafts", "Crafts, Hobbies & Home"],

            ["outdoors", "Sports & Outdoors"],
            ["sports", "Sports & Outdoors"],

            ["travel", "Travel Books"],

            ["study aids", "Study Guide & Test Preparation"],
            ["test preparation", "Study Guide & Test Preparation"],

            ["graphic novel", "Comics & Graphic Novels"],
            ["comics", "Comics & Graphic Novels"],

            ["romance", "Romance & Love"],
            ["love", "Romance & Love"],

            ["sci-fi", "Science Fiction & Fantasy"],
            ["science fiction", "Science Fiction & Fantasy"],
            ["fantasy", "Science Fiction & Fantasy"],

            ["biography", "Biographies & History"],
            ["memoir", "Biographies & History"],
            ["history", "Biographies & History"],

            ["politics", "Politics & Social Sciences"],
            ["social science", "Politics & Social Sciences"],

            ["engineering", "Engineering & Transportation"],
            ["transportation", "Engineering & Transportation"],

            ["math", "Science & Math"],
            ["science", "Science & Math"],

            ["humor", "Humor & Entertainment"],
            ["entertainment", "Humor & Entertainment"],

            ["parenting", "Parenting & Relationships"],
            ["relationships", "Parenting & Relationships"],

            ["self-help", "Self-Help & Personal Growth"],
            ["personal growth", "Self-Help & Personal Growth"],

            ["puzzles", "Puzzles & Games"],
            ["games", "Puzzles & Games"],

            ["affirmation", "Affirmations & Stress Reduce"],
            ["stress", "Affirmations & Stress Reduce"],
        ];

        for (const [needle, target] of map) {
            if (hay.includes(needle)) {
                const g = allGenres.find(x => x.genre === target);
                if (g) return g;
            }
        }
        return null;
    };


    // 🔹 Resize editor
    useEffect(() => {
        loadBookDataFromLocalStorage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setNewdBook((prevBook) => {
            let updatedBook = { ...prevBook, [name]: checked };

            if (name === "audio_exclusive_flag" && checked) {
                updatedBook.audio_non_exclusive_flag = false;
            }
            if (name === "audio_non_exclusive_flag" && checked) {
                updatedBook.audio_exclusive_flag = false;
            }
            if (name === "audio_flag" && !checked) {
                updatedBook.audio_exclusive_flag = false;
                updatedBook.audio_non_exclusive_flag = false;
            }
            if (name === "kindle_flag" && !checked) {
                updatedBook.kindle_unlimited_flag = false;
            }
            return updatedBook;
        });
    };

    const manuscriptRequirementSatisfied = noManuscript || Boolean(tempPDFFile && pdfFileTitle);
    const manuscriptUploadInProgress = (uploadProgress > 0 && uploadProgress < 100) && !noManuscript;
    const hasAnyBookFormat = Boolean(
        newBook.paper_back_flag ||
        newBook.kindle_flag ||
        newBook.hard_cover_flag ||
        newBook.audio_flag ||
        newBook.kindle_unlimited_flag
    );
    const hasAnyAsin = Boolean(
        paperbackAsinState ||
        kindleAsinState ||
        hardcoverAsinState ||
        audioAsinState ||
        audibleAsinState
    );
    const isFormValid = Boolean(
        user.user.id &&
        book.selectedGenre.id &&
        book.selectedLanguage.id &&
        titleState &&
        authorState &&
        summaryState &&
        hasAnyBookFormat &&
        hasAnyAsin &&
        coverFileState &&
        manuscriptRequirementSatisfied &&
        (!newBook.audio_non_exclusive_flag || audioBookLinkState)
    );

    const getFormValidationMessage = () => {
        if (!user.user.id) return "User session is missing. Please refresh the page.";
        if (!titleState?.trim()) return "Enter the book title, please.";
        if (!authorState?.trim()) return "Enter the author name, please.";
        if (!book.selectedLanguage?.id) return "Select the book language, please.";
        if (!book.selectedGenre?.id) return "Select the book genre, please.";
        if (!hasAnyBookFormat) return "Select at least one book format, please.";
        if (!hasAnyAsin) return "Enter at least one ASIN, please.";
        if (!summaryState?.trim()) return "Enter the book summary, please.";
        if (!coverFileState) return "Upload the book cover image, please.";
        if (!manuscriptRequirementSatisfied) return "Upload a manuscript or tick \"I don't want to upload the manuscript\".";
        if (newBook.audio_non_exclusive_flag && !audioBookLinkState?.trim()) return "Enter the audiobook download link, please.";
        return "Fill all required fields, please.";
    };

    const handleSubmitBookToModeration = (options = {}) => {
        const skipSafety = options?.skipSafety === true;
        const trimmedTitle = titleState.trim();
        const trimmedAuthor = authorState.trim();
        const trimmedSubtitle = subtitleState.trim();
        setTitleState(trimmedTitle);
        setAuthorState(trimmedAuthor);
        setSubTitleState(trimmedSubtitle);

        if (!manuscriptRequirementSatisfied) {
            toast.warn("Upload a manuscript or tick \"I don't want to upload the manuscript\".", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        if (!isFormValid) {
            toast.warn(getFormValidationMessage(), { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
        if (!skipSafety) {
            const conflict = findReviewerPenNameConflict(user?.user?.amz_name, [trimmedAuthor]);
            if (conflict) {
                setReviewerSafetyConflict(conflict);
                return;
            }
        }
        addBook();
    };

    // ==== LocalStorage helpers ====
    const saveBookDataToLocalStorage = (updatedFields = {}) => {
        const existingData = JSON.parse(localStorage.getItem("productForm")) || {};
        const bookData = {
            ...existingData,
            ...updatedFields,
        };
        if (updatedFields.no_manuscript !== undefined) {
            bookData.no_manuscript = updatedFields.no_manuscript ? true : false;
        }
        if (updatedFields.public_catalog_visible !== undefined) {
            bookData.public_catalog_visible = updatedFields.public_catalog_visible ? true : false;
        }
        localStorage.setItem("productForm", JSON.stringify(bookData));

    };

    const loadBookDataFromLocalStorage = () => {
        const savedData = localStorage.getItem("productForm");
        if (savedData) {
            const bookData = JSON.parse(savedData);
            setTitleState(bookData.title || "");
            setSubTitleState(bookData.subtitle || "");
            setAuthorState(bookData.author || "");
            setSummaryState(bookData.summary || "");
            setPaperBackAsinState(bookData.pb_asin || bookData.paper_back_asin || "");
            setAmzlinkState(bookData.amz_link || "");
            setKindleAsinState(bookData.k_asin || bookData.kindle_asin || "");
            setHardCoverAsinState(bookData.hc_asin || bookData.hard_cover_asin || "");
            setAudioAsinState(bookData.audio_asin || "");
            setAudibleAsinState(bookData.audible_asin || "");
            setAudioBookLinkState(bookData.audible_link || "");
            setSummaryState(bookData.summary || "");

            setTempPDFFile(bookData.book_temp_file_name || "");
            setTempPDFFile(bookData.temp_pdf_file || "");
            setPdfFileTitle(bookData.pdf_file_title || "");
            if (bookData.no_manuscript !== undefined) {
                setNoManuscript(storedBool(bookData.no_manuscript, false));
            }
            if (bookData.public_catalog_visible !== undefined) {
                setPublicCatalogVisible(storedBool(bookData.public_catalog_visible, true));
            }

            if (bookData.cover_file) {
                const restoredBlob = base64ToBlob(bookData.cover_file);
                const restoredFile = new File([restoredBlob], bookData.cover_file_name, { type: "image/jpeg" });
                setCoverFileState(restoredFile);
                setCoverPreview(bookData.cover_file);
            }

            const restoredLanguage = bookData.language?.id
                ? bookData.language
                : autoMatchLanguage(bookData.language?.language || bookData.language?.language_short || bookData.language, book.languages) || bookData.language || {};
            const restoredGenre = bookData.genre?.id
                ? bookData.genre
                : autoPickGenre([], bookData.genre?.genre || bookData.genre?.category || bookData.genre, book.genres) || bookData.genre || {};
            book.setSelectedLanguage(restoredLanguage);
            book.setSelectedGenre(restoredGenre);
            setNewdBook((prev) => ({
                ...prev,
                ...getStoredBookTypes(bookData),
            }));
        }
    };

    useEffect(() => {
        const savedData = localStorage.getItem("productForm");
        if (!savedData) return;

        try {
            const bookData = JSON.parse(savedData);
            if (!book.selectedLanguage?.id) {
                const restoredLanguage = bookData.language?.id
                    ? bookData.language
                    : autoMatchLanguage(bookData.language?.language || bookData.language?.language_short || bookData.language, book.languages);
                if (restoredLanguage) book.setSelectedLanguage(restoredLanguage);
            }
            if (!book.selectedGenre?.id) {
                const restoredGenre = bookData.genre?.id
                    ? bookData.genre
                    : autoPickGenre([], bookData.genre?.genre || bookData.genre?.category || bookData.genre, book.genres);
                if (restoredGenre) book.setSelectedGenre(restoredGenre);
            }
        } catch (_) {}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [book.languages?.length, book.genres?.length]);

    const clearBookDataFromLocalStorage = () => {
        localStorage.removeItem("productForm");
    };

    // ==== Upload PDF ====
    const selectBookFile = (e) => {
        const input = e.target;
        const file = input.files[0];
        input.value = "";

        if (!file) {
            toast.error("Error: No file selected.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
        if (file.type !== "application/pdf") {
            toast.error(`Error: File "${file.name}" is not a PDF.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
        const maxFileSize = 500 * 1024 * 1024;
        if (file.size > maxFileSize) {
            toast.error(`Error: File "${file.name}" exceeds 500MB limit.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        setPdfFile(file);
        setPdfFileTitle(file.name);
        saveBookDataToLocalStorage({ pdf_file_title: file.name });

        const formData = new FormData();
        formData.append("book_download_temp", file);

        try {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", process.env.REACT_APP_API_URL + "api/book/temp", true);

            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    const percentComplete = Math.round((event.loaded / event.total) * 100);
                    setUploadProgress(percentComplete >= 100 ? 99 : percentComplete);
                }
            };

            xhr.onload = () => {
                if (xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText);
                    const tempFileName = response.tempPDFFile;
                    toast.success(response.message, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                    setTempPDFFile(tempFileName);
                    saveBookDataToLocalStorage({ temp_pdf_file: tempFileName });
                    setUploadProgress(100);
                } else {
                    let errorMessage = `Upload failed: ${xhr.status}`;
                    try {
                        errorMessage = JSON.parse(xhr.responseText)?.message || errorMessage;
                    } catch (_) {}
                    toast.error(errorMessage, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                    setUploadProgress(-1);
                }
            };

            xhr.onerror = () => {
                toast.error("Error uploading file.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setUploadProgress(-1);
            };

            xhr.send(formData);
        } catch (error) {
            toast.error(`Error sending file: ${error.message}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    };

    const triggerFileInputBook = () => {
        document.getElementById("fileInputBook").click();
    };

    const triggerFileInput = () => {
        const input = document.getElementById("fileInput");
        input.value = "";
        input.click();
    };

    const handleFileChange = (e) => {
        const input = e.target;
        const file = e.target.files[0];
        input.value = "";
        if (file && file.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onload = (event) => {
                const imageBase64 = event.target.result;
                setCoverPreview(imageBase64);
                saveBookDataToLocalStorage({
                    cover_file: imageBase64,
                    cover_file_name: file.name,
                });
            };
            reader.readAsDataURL(file);
        }
    };

    const base64ToBlob = (base64) => {
        const byteCharacters = atob(base64.split(',')[1]);
        const byteArrays = [];
        for (let i = 0; i < byteCharacters.length; i++) {
            byteArrays.push(byteCharacters.charCodeAt(i));
        }
        return new Blob([new Uint8Array(byteArrays)], { type: 'image/jpeg' });
    };

    const resetDataFields = () => {
        localStorage.removeItem("temp_pdf_file");
        setTempPDFFile(null);
        setPdfFileTitle('');

        setTitleState('');
        setSubTitleState('');
        setAuthorState('');
        setSummaryState('');
        setAmzlinkState('');
        setPaperBackAsinState('');
        setKindleAsinState('');
        setHardCoverAsinState('');
        setAudioAsinState('');
        setAudibleAsinState('');
        setAudioBookLinkState('');
        setPdfFile(null);
        setSelectedWordCount({});
        setAmzlinkState('');
        setKindlePriceState('null');
        setPaperbackPriceState('null');
        setHardcoverPriceState(null);

        book.setSelectedLanguage({});
        book.setSelectedGenre({});

        setCoverFileState(null);
        setCoverPreview(defaultImage);
        setDescription('');
        setNoManuscript(false);
    };

    const addBook = async () => {
        setLoading(true);
        setError('');
        try {
            const formData = new FormData();

            // Функция для добавления только валидных значений
            const appendIfValid = (key, value, isNumber = false) => {
                if (value !== undefined) {
                    formData.append(key, isNumber ? Number(value) : value);
                }
            };
            // helpers
            const appendIfString = (key, value) => {
                if (value !== undefined && value !== null && `${value}`.trim() !== "") {
                    formData.append(key, value);
                }
            };

            formData.append('userId', user.user.id);
            formData.append('booksGenreId', book.selectedGenre.id);
            formData.append('booksPriceId', 1);
            formData.append('booksLanguageId', book.selectedLanguage.id);
            formData.append('booksTypeId', 1);
            formData.append('title', titleState);
            formData.append('subtitle', subtitleState);
            formData.append('author', authorState);
            formData.append('book_type', 'book');
            formData.append('language', book.selectedLanguage.language);
            formData.append('amz_price', '');
            formData.append('summary', summaryState);
            formData.append('status', 'NEW');
            formData.append('message', '');
            formData.append('message_flag', false);
            formData.append('amz_link', '');
            formData.append('paper_back_flag', newBook.paper_back_flag);
            formData.append('kindle_flag', newBook.kindle_flag);
            formData.append('kindle_unlimited_flag', newBook.kindle_unlimited_flag);
            formData.append('audio_exclusive_flag', newBook.audio_exclusive_flag);
            formData.append('audio_non_exclusive_flag', newBook.audio_non_exclusive_flag);
            formData.append('hard_cover_flag', newBook.hard_cover_flag);
            formData.append('audio_flag', newBook.audio_flag);
            formData.append('default_price', 500);
            formData.append('default_decrement', 0);
            formData.append('paper_back_asin', paperbackAsinState || '');
            formData.append('kindle_asin', kindleAsinState || '');
            formData.append('hard_cover_asin', hardcoverAsinState || '');
            formData.append('audio_asin', audioAsinState || '');
            formData.append('audio_audible_asin', audibleAsinState || '');
            formData.append('audio_download_link_ned', audioBookLinkState || '');
            formData.append('total_words', selectedWordCount?.count || 1000);
            formData.append('description_full', description || summaryState || '');
            // строковые цены (как есть)
            appendIfString("kindle_price_on_amazon", kindlePriceState);
            appendIfString("paper_back_price_on_amazon", paperbackPriceState);
            appendIfString("hard_cover_price_on_amazon", hardcoverPriceState);
            appendIfValid('kindle_list_price_on_amazon_decimal', kindlePriceState, true);
            appendIfValid('paper_back_list_price_on_amazon_decimal', paperbackPriceState, true);
            appendIfValid('hard_cover_list_price_on_amazon_decimal', hardcoverPriceState, true);
            formData.append('no_manuscript', noManuscript ? '1' : '0');
            formData.append('public_catalog_visible', publicCatalogVisible ? '1' : '0');
            formData.append('last_update_book_data_from_amazon_date', Math.floor(Date.now()/1000));

            if (!noManuscript && tempPDFFile) {
                formData.append("book_download", tempPDFFile);
            }
            if (coverFileState) {
                formData.append("cover_file", coverFileState);
            } else {
                toast.warn("No cover image found!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            }

            formData.append("territories_mode", territoriesMode);

            if (territoriesMode === "WORLDWIDE") {
                formData.append("available_marketplaces", "[]");
            } else {
                formData.append("available_marketplaces", JSON.stringify(availableMarketplaces));
            }

            const response = await fetch(`${process.env.REACT_APP_API_URL}api/book/`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`Server returned ${response.status}`);
            }

            const result = await response.json();
            const createdBook = result.book;

            toast.success(result.message, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

            const updatedBooks = await fetchCurrentUserBooks(user?.user?.id);
            book.setCurrentUserBooks(updatedBooks);
            book.setSelectedCurrentUserBook({ formData });

            const foundBook = updatedBooks.find(b => b.id === createdBook.id);
            if (foundBook) {
                book.setSelectedCurrentUserBook(foundBook);
                user.setActiveComponent("BookFull");
            }

            clearBookDataFromLocalStorage();
            resetDataFields();
        } catch (e) {
            console.error(e);
            toast.error(`❌ Error: ${e.message}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setError(e.message || 'An error occurred while uploading your book.');
        } finally {
            setLoading(false);
        }
    };

    // 🔹 Шаг 0: граб из Amazon
    const fetchFromAmazon = async () => {
        const raw = (amzlinkState || "").trim();
        if (!raw) {
            toast.info("Paste your Amazon book link first.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
        setLoading(true);
        try {
            const data = await getFullBookDataUrlApi(raw);

            await downloadAndSetCover(
                data?.main_image ||
                data?.image_large ||
                data?.image_medium ||
                (Array.isArray(data?.images) ? data.images[0] : '')
            );

            // Заголовки
            setTitleState(data?.title || "");
            setSubTitleState(data?.subtitle || "");
            const authorsStr = (data?.authors_str?.trim?.()) ||
                (Array.isArray(data?.authors) ? data.authors.join(", ") : "") || "";
            setAuthorState(authorsStr);

            //Description
            setSummaryState(data?.description_first10);

            // Флаги форматов
            setNewdBook(prev => ({
                ...prev,
                kindle_flag: !!data?.kindle,
                kindle_unlimited_flag: !!data?.kindle_unlimited,
                paper_back_flag: !!data?.pb,
                hard_cover_flag: !!data?.hc,
                audio_flag: !!data?.audio,
                // 98% кейсов — аудио эксклюзив; ставим true по умолчанию
                audio_exclusive_flag: !!data?.audio,
                audio_non_exclusive_flag: false, // дефолтно выключаем non-exclusive
            }));

            // ASINы
            setKindleAsinState(data?.kindle_asin || "");
            setPaperBackAsinState(data?.pb_asin || "");
            setHardCoverAsinState(data?.hc_asin || "");
            setAudioAsinState(data?.audio_asin || "");
            setAudibleAsinState(data?.audio_audible_asin || data?.audible_asin || "");
            setKindlePriceState(safeVal(data?.prices?.kindle?.value));
            setPaperbackPriceState(safeVal(data?.prices?.paperback?.value));
            setHardcoverPriceState(safeVal(data?.prices?.hardcover?.value));

            // Превью обложки (URL). Это только превью — файл юзер всё равно загрузит на шаге обложки.
            if (data?.main_image) {
                setCoverPreview(data.main_image);
            }

            // ЯЗЫК
            if (data?.language && Array.isArray(book.languages) && book.languages.length) {
                const matchedLang = autoMatchLanguage(data.language, book.languages);
                if (matchedLang) {
                    book.setSelectedLanguage(matchedLang);
                    // можно сразу и в localStorage положить
                    saveBookDataToLocalStorage({ language: matchedLang });
                }
            }

            // ПРИБЛИЖЁННЫЙ ОБЪЁМ СЛОВ по print_length
            if (data?.print_length) {
                const bucket = estimateWordCountBucket(data.print_length, wordCountOptions);
                if (bucket) {
                    setSelectedWordCount(bucket);
                    saveBookDataToLocalStorage({ total_words: bucket.count });
                }
            }

            // ЖАНР по крошкам/категориям
            if ((data?.categories?.length || data?.categories_path) && Array.isArray(book.genres) && book.genres.length) {
                const guessed = autoPickGenre(data.categories || [], data.categories_path || "", book.genres);
                if (guessed) {
                    book.setSelectedGenre(guessed);
                    saveBookDataToLocalStorage({ genre: guessed });
                }
            }


            // Сохраним часть в localStorage, чтобы не потерялось при перезагрузке
            saveBookDataToLocalStorage({
                amz_link: raw,
                title: data?.title || "",
                subtitle: data?.subtitle || "",
                author: authorsStr,
                pb_asin: data?.pb_asin || "",
                k_asin: data?.kindle_asin || "",
                hc_asin: data?.hc_asin || "",
                audio_asin: data?.audio_asin || "",
                audible_asin: data?.audio_audible_asin || data?.audible_asin || "",
                summary: data?.description_first10 || "",
                bookTypes: {
                    paperBack: !!data?.pb,
                    kindle: !!data?.kindle,
                    kindle_u: !!data?.kindle_unlimited,
                    hardCover: !!data?.hc,
                    audio: !!data?.audio,
                    audio_ex: false,
                    audio_non_ex: false,
                }
            });

            toast.success("Done! Double-Check the Details!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

            // Автопереход на следующий шаг (к твоему прежнему Step 1 — выбор языка/жанра/типов)
            setNextStep({
                step0: false,
                step1: true,
                step2: false,
                step3: false,
                step4: false,
                step5: false,
                step6: false
            });
            setStep(1);

            // допустим, после удачного ответа grab-функции:
            const imgUrl =
                data?.main_image ||
                data?.image_large ||
                data?.image_medium ||
                (Array.isArray(data?.images) ? data.images[0] : '') ||
                '';

            if (imgUrl) {
                await downloadAndSetCover(imgUrl, (data?.title || 'cover').replace(/[^\w-]+/g, '_'));
            }

        } catch (e) {
            console.error(e);
            toast.error(`Grab failed: ${e?.response?.data?.message || e.message}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (error) {
            toast.error(`❌ ${error}`, { closeOnClick: true, pauseOnHover: true, draggable: true, theme: 'colored', position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    }, [error]);

    const addBookInDash = () => {
        user?.setActiveComponent("AddBookInDashboard");
    }
    const autoAddBookInDash = () => {
        user?.setActiveComponent("AddBookByGrabFromAmazon");
    }
    useEffect(() => {
        if (loading) {
            setProgress(0);
            const start = Date.now();
            const timer = setInterval(() => {
                const elapsed = Date.now() - start;
                const pct = Math.min(100, (elapsed / 1500) * 100); // за 1.5 секунду доходит до 100
                setProgress(pct);
                if (pct >= 100) clearInterval(timer);
            }, 50);
            return () => clearInterval(timer);
        }
    }, [loading]);


    return (
        <>
            <ReviewerNameSafetyModal
                show={!!reviewerSafetyConflict}
                conflict={reviewerSafetyConflict}
                onCancel={() => setReviewerSafetyConflict(null)}
                onContinue={() => {
                    setReviewerSafetyConflict(null);
                    handleSubmitBookToModeration({ skipSafety: true });
                }}
            />
            <Card className="p-3 w-100 mt-2">
                {/* Header: title + Back button on step > 0 */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center flex-wrap gap-2">
                    {/* Header: title + Back button on step > 0 */}
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center flex-wrap gap-2 w-100">
                        <h5 className="text-muted mb-2 mb-md-0">
                        {step === 0
                                ? "Automatically Add a New Book to Virtalibry System:"
                                : "Great! Review Everything, Upload your file, then click Submit for Moderation:"}
                        </h5>

                        {/* Кнопки Manual / Automatic справа */}
                        {step === 0 && (<>
                        <ButtonGroup>
                            <Button
                                variant={user?.activeComponent === "AddBookByGrabFromAmazon" ? "success" : "outline-success"}
                                size="sm"
                                onClick={autoAddBookInDash}
                            >
                                Automatically
                            </Button>
                            <Button
                                variant={user?.activeComponent === "AddBookInDashboard" ? "success" : "outline-success"}
                                size="sm"
                                onClick={addBookInDash}
                            >
                                Manually
                            </Button>
                        </ButtonGroup>
                        </>)}
                        {step > 0 && (
                            <Button
                                className="d-inline-flex align-items-center border btn-secondary btn-sm"
                                onClick={() => {
                                    setNextStep({
                                        step0: true, step1: false, step2: false, step3: false, step4: false, step5: false, step6: false
                                    });
                                    setStep(0); // вернуться к полю линка, данные не очищаем
                                }}
                                title="Back to Step 1"
                            >
                                <i className="me-2 fas fa-arrow-circle-left"></i> Back
                            </Button>

                        )}

                    </div>



                </div>

                {/* === STEP 0: только линк + Grab === */}
                {step === 0 && (<>
                    <div className="text-muted small">
                        <p className="mb-1 mt-2">
                            In Automatic mode, Virtalibry will fetch and clean the main book data for you.
                            The flow is quick and simple — just two steps.
                        </p>

                        <p className="mb-1">
                            <strong>Step 1:</strong> Paste your <em>Amazon book link</em> and press <em>Fetch Book Data from Amazon</em>.
                            The system will automatically collect: <em>Title</em>, <em>Subtitle</em>, <em>Author</em>, <em>Language</em>, <em>Genre</em>,
                            an estimated <em>Word Count</em>, available formats (<em>Kindle</em>, <em>Paperback</em>, <em>Hardcover</em>, <em>Audio</em>),
                            whether the book is in <em>Kindle Unlimited</em>, all available <em>ASINs</em>, and the <em>Description</em> (first 10 lines from your listing).
                            Extra spaces and service labels like “(Author)” are cleaned automatically.
                        </p>

                        <p className="mb-1">
                            <strong>Step 2:</strong> Review the details, edit if needed, upload your <em>manuscript (PDF)</em>, and submit for moderation.
                            Pay special attention to the <em>Word Count</em>: for low-content books the script may miscalculate it, since it uses page count data,
                            and if there is no <em>Paperback/Hardcover</em> edition the word count may not be generated at all.
                            The rest of the fields (title, subtitle, author, language, genre, Kindle Unlimited flag, ASINs, description) are usually stable,
                            but please double-check everything carefully. Use the <em>Check</em> buttons next to each ASIN to make sure they lead to the right Amazon page.
                            Once everything looks correct, upload your PDF manuscript and click “Submit for Moderation.” That’s it!
                        </p>
                    </div>

                    <Col md={12} className="mt-2">
                        <Card className="mt-2 mb-2 border rounded-1 border-secondary ">
                            <Card.Header className="py-1 small">Fetch Book Data from Amazon. Insert Link, Grab, then continue.</Card.Header>
                            <Card.Body className="pt-2">
                                <Form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        fetchFromAmazon();
                                        const link = amzlinkState.trim();
                                        saveBookDataToLocalStorage({ amz_link: link });
                                    }}
                                    className="small"
                                >
                                    <InputGroup className="mb-2 mt-2 border rounded-1 border-secondary" size="sm">
                                        <Form.Control
                                            type="text"
                                            placeholder="Paste your Amazon book link…"
                                            value={amzlinkState}
                                            onChange={(e) => setAmzlinkState(e.target.value)}
                                            disabled={loading}
                                            size="sm"
                                            className="border "
                                        />
                                        <Button
                                            variant="success"
                                            onClick={fetchFromAmazon}
                                            disabled={loading}
                                            type="button"
                                            size="sm"
                                            className="d-flex align-items-center justify-content-center"
                                            title="Grab and parse book data from Amazon"
                                        >
                                            {loading ? (
                                                <>
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                        className="me-2"
                                                    />
                                                    Fetching Book Data…
                                                </>
                                            ) : (
                                                <>
                                                    <span className="d-none d-sm-inline">Fetch Book Data from Amazon</span>
                                                    <span className="d-inline d-sm-none">Fetch</span>
                                                </>
                                            )}
                                        </Button>

                                    </InputGroup>
                                    <div className="text-muted small">
                                        Paste the full product URL from Amazon (e.g. https://www.amazon.com/dp/XXXXXXXXXX) and press <strong>Fetch Book Data from Amazon</strong>.
                                    </div>
                                </Form>
                                {loading && (
                                    <div className="mt-2 w-100">
                                        <ProgressBar animated now={progress} variant="success" />
                                        <div className="small text-muted mt-1 text-center">
                                            We’re grabbing your book details, almost there…
                                        </div>
                                    </div>
                                )}

                            </Card.Body>
                        </Card>
                    </Col>
                </>)}

                {/* === STEP >= 1: верстка как в Edit (бордеры secondary) === */}
                {step > 0 && (
                    <Form className="mt-2 mb-0">
                        {/* ===== Title / Subtitle / Author ===== */}
                        <Row className="mb-0 mt-0 p-2 small">
                            <Col md={4}>
                                <Form.Group className="mb-0">
                                    <Form.Label className="text-muted fw-semibold mb-0">Book Title:</Form.Label>
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        placeholder="Enter book title"
                                        value={titleState}
                                        onChange={e => {
                                            const raw = e.target.value;
                                            const noCyrillic = raw.replace(/[а-яёА-ЯЁ]/g, '');
                                            setTitleState(noCyrillic);
                                        }}
                                        onBlur={() => setTitleState((v) => (v || '').replace(/[:]+$/, '').trim())}
                                        disabled={loading}
                                        className="border "
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={5}>
                                <Form.Group className="mb-0">
                                    <Form.Label className="text-muted fw-semibold mb-0">Book Subtitle:</Form.Label>
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        placeholder="Enter book subtitle"
                                        value={subtitleState}
                                        onChange={e => {
                                            const raw = e.target.value;
                                            const noCyrillic = raw.replace(/[а-яёА-ЯЁ]/g, '');
                                            setSubTitleState(noCyrillic);
                                        }}
                                        onBlur={() => setSubTitleState((v) => (v || '').replace(/[:]+$/, '').trim())}
                                        disabled={loading}
                                        className="border "
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group className="mb-0">
                                    <Form.Label className="text-muted fw-semibold mb-0">Author Name:</Form.Label>
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        placeholder="Enter author name"
                                        value={authorState}
                                        onChange={e => {
                                            const raw = e.target.value;
                                            const noCyrillic = raw.replace(/[а-яёА-ЯЁ]/g, '');
                                            setAuthorState(noCyrillic);
                                        }}
                                        onBlur={() => setAuthorState((v) => (v || '').replace(/:/g, '').trim())}
                                        disabled={loading}
                                        className="border "
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* ===== Language / Word Count / Genre ===== */}
                        <Row className="mb-0 p-2 flex-column flex-md-row small">
                            <Col xs={12} md={4} className="pe-md-2 mb-2 mb-md-0">
                                <div className="d-flex flex-column flex-md-row gap-2">
                                    {/* Language */}
                                    <div className="flex-grow-1">
                                        <span className="text-muted fw-semibold mb-1 d-block">Language:</span>
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                variant="small"
                                                size="sm"
                                                className="w-100 border small bg-white text-start"
                                            >
                                                {book.selectedLanguage?.language || "Select language"}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
                                                {book.languages.map((lang) => (
                                                    <Dropdown.Item
                                                        onClick={() => book.setSelectedLanguage(lang)}
                                                        key={lang.id}
                                                        className="small text-muted"
                                                    >
                                                        {lang.language}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>

                                    {/* Word Count */}
                                    <div className="flex-grow-1">
                                        <span className="text-muted fw-semibold mb-1 d-block">Approx. Word Count:</span>
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                variant="small"
                                                size="sm"
                                                className="w-100 border small bg-white text-start"
                                            >
                                                {selectedWordCount?.label || "Select…"}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
                                                {wordCountOptions.map((opt) => (
                                                    <Dropdown.Item
                                                        key={opt.id}
                                                        onClick={() => setSelectedWordCount(opt)}
                                                        className="small text-muted"
                                                    >
                                                        {opt.label}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>

                                {/* Genre */}
                                <div className="d-flex flex-column mt-3">
                                    <span className="text-muted fw-semibold mb-0">Genre of Book:</span>
                                    <Dropdown>
                                        <Dropdown.Toggle
                                            variant="small"
                                            size="sm"
                                            className="w-100 border small bg-white text-start"
                                        >
                                            {book.selectedGenre?.genre || "Select Genre"}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
                                            {book.genres.map((gen) => (
                                                <Dropdown.Item
                                                    onClick={() => book.setSelectedGenre(gen)}
                                                    key={gen.id}
                                                    className="small text-muted"
                                                >
                                                    {gen.genre}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </Col>

                            {/* Types (Kindle/Paperback/Hardcover/Audio) */}
                            <Col xs={12} md={5} className="px-md-2 mb-3 mb-md-0">
                                <span className="text-muted fw-semibold">Available Types for this Book:</span>
                                <Card className="p-2 mt-0 border ">
                                    <Form.Check
                                        className="custom-checkbox mb-1"
                                        type="checkbox"
                                        label="This Book is Available in Kindle Version"
                                        name="kindle_flag"
                                        checked={newBook.kindle_flag}
                                        onChange={handleCheckboxChange}
                                    />
                                    <Form.Check
                                        className="custom-checkbox mb-1"
                                        type="checkbox"
                                        label="This Book is Available in Paperback"
                                        name="paper_back_flag"
                                        checked={newBook.paper_back_flag}
                                        onChange={handleCheckboxChange}
                                    />
                                    <Form.Check
                                        className="custom-checkbox mb-1"
                                        type="checkbox"
                                        label="This Book is Available in Hardcover"
                                        name="hard_cover_flag"
                                        checked={newBook.hard_cover_flag}
                                        onChange={handleCheckboxChange}
                                    />
                                    <Form.Check
                                        className="custom-checkbox mb-0"
                                        type="checkbox"
                                        label="This Book is Available in Audio Format"
                                        name="audio_flag"
                                        checked={newBook.audio_flag}
                                        onChange={handleCheckboxChange}
                                    />
                                </Card>
                            </Col>

                            {/* Kindle Unlimited + Audio distribution options */}
                            <Col xs={12} md={3} className="ps-md-2">
                                {newBook.kindle_flag && (
                                    <div>
                                        <span className="text-muted fw-semibold mb-0">Kindle Unlimited Option?</span>
                                        <Card className="p-2 mt-0 mb-0 border ">
                                            <Form.Check
                                                type="checkbox"
                                                className="custom-checkbox mb-0"
                                                label="Yes, it's Kindle Unlimited!"
                                                name="kindle_unlimited_flag"
                                                checked={newBook.kindle_unlimited_flag}
                                                onChange={handleCheckboxChange}
                                            />
                                        </Card>
                                    </div>
                                )}

                                {newBook.audio_flag && (
                                    <div className="mt-2">
                                        <span className="text-muted fw-semibold mb-1 mt-2">Type of Audio Distribution?</span>
                                        <Card className="p-2 mt-0 border ">
                                            <Form.Check
                                                type="checkbox"
                                                className="custom-checkbox mb-1"
                                                label="Exclusive Distribution"
                                                name="audio_exclusive_flag"
                                                checked={newBook.audio_exclusive_flag}
                                                onChange={handleCheckboxChange}
                                            />
                                            <Form.Check
                                                type="checkbox"
                                                className="custom-checkbox mb-0"
                                                label="Non-Exclusive Distribution"
                                                name="audio_non_exclusive_flag"
                                                checked={newBook.audio_non_exclusive_flag}
                                                onChange={handleCheckboxChange}
                                            />
                                        </Card>
                                    </div>
                                )}
                            </Col>
                        </Row>

                        {/* COVER + UPLOAD PDF (адаптировано, все элементы с ) */}
                        <Row className="mb-0 p-2 flex-column flex-md-row small">
                            {/* COVER */}
                            <Col md={4} className="mt-0 p-2">
                                <Card className="mb-0 p-3 mt-0 border ">
                                    {coverPreview && (
                                        <div className="text-center mb-0 mt-0">
                                            <img
                                                src={coverPreview}
                                                alt="Cover Preview"
                                                className="img-fluid border-0 rounded"
                                                style={{ objectFit: "cover" }}
                                                width={300}
                                            />
                                        </div>
                                    )}
                                </Card>

                                <Row className="mb-3 m-lg-2 m-auto mt-3">
                                    <div className="d-flex justify-content-center mb-0 mt-1">
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-success me-2"
                                            onClick={triggerFileInput}   // существующий хэндлер
                                            disabled={loading}
                                        >
                                            Upload New Cover
                                        </button>

                                        {/* скрытый input для выбора картинки обложки */}
                                        <input
                                            type="file"
                                            id="fileInput"
                                            style={{ display: "none" }}
                                            onChange={handleFileChange}  // существующий хэндлер
                                        />
                                    </div>
                                </Row>
                            </Col>

                            {/* UPLOAD PDF */}
                            <Col md={8} className="mt-0 p-2">

                                <Card className="p-2">
                                    <Row className="mb-2">
                                        {(newBook.paper_back_flag || newBook.kindle_flag) && (
                                            <Col md={6} style={{ maxWidth: "100%" }}>
                                                {newBook.kindle_flag && (
                                                    <Form className="mt-0 mb-0 p-1">
                                                        <Form.Label className="text-muted fw-semibold mb-0">Kindle ASIN:</Form.Label>
                                                        <div className="d-flex align-items-center">
                                                            <Form.Control
                                                                className="border border-secondary form-control-sm"
                                                                value={kindleAsinState}
                                                                onChange={(e) => {
                                                                    const upper = e.target.value.replace(/\s/g, "").toUpperCase();
                                                                    setKindleAsinState(upper);
                                                                }}
                                                                placeholder="Enter Kindle ASIN..."
                                                                disabled={loading}
                                                            />
                                                            <Button
                                                                variant="info"
                                                                className="ms-2 btn-sm"
                                                                disabled={!kindleAsinState}
                                                                onClick={async () => {
                                                                    try {
                                                                        const targetUrl = `${user?.user?.amz_country}/dp/${kindleAsinState}`;
                                                                        const response = await getRedirectUrlApi(targetUrl);
                                                                        if (response?.redirectUrl) {
                                                                            window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                        } else {
                                                                            console.error("Failed to get redirect URL");
                                                                        }
                                                                    } catch (err) {
                                                                        console.error("Redirect error:", err);
                                                                    }
                                                                }}
                                                            >
                                                                Check
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                )}

                                                {newBook.paper_back_flag && (
                                                    <Form className="mt-0 mb-0 p-1">
                                                        <div className="fw-semibold mb-0 text-muted">Paperback ASIN:</div>
                                                        <div className="d-flex align-items-center">
                                                            <Form.Control
                                                                className="border border-secondary form-control-sm"
                                                                value={paperbackAsinState}
                                                                onChange={(e) => {
                                                                    const cleaned = e.target.value.trim().toUpperCase();
                                                                    setPaperBackAsinState(cleaned);
                                                                }}
                                                                placeholder="Enter Paperback ASIN..."
                                                                disabled={loading}
                                                            />
                                                            <Button
                                                                variant="info"
                                                                className="ms-2 btn-sm"
                                                                disabled={!paperbackAsinState}
                                                                onClick={async () => {
                                                                    try {
                                                                        const targetUrl = `${user?.user?.amz_country}/dp/${paperbackAsinState}`;
                                                                        const response = await getRedirectUrlApi(targetUrl);
                                                                        if (response?.redirectUrl) {
                                                                            window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                        } else {
                                                                            console.error("Failed to get redirect URL");
                                                                        }
                                                                    } catch (err) {
                                                                        console.error("Redirect error:", err);
                                                                    }
                                                                }}
                                                            >
                                                                Check
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                )}

                                                {(newBook.audio_non_exclusive_flag ||
                                                    newBook.audio_exclusive_flag) && (
                                                    <Form className="mt-0 mb-0 p-1">
                                                        <div className="fw-semibold mb-0 text-muted">Audible ASIN:</div>
                                                        <div className="d-flex align-items-center">
                                                            <Form.Control
                                                                className="border border-secondary form-control-sm"
                                                                value={audibleAsinState}
                                                                onChange={(e) => {
                                                                    const cleaned = e.target.value.replace(/\s/g, "").toUpperCase();
                                                                    setAudibleAsinState(cleaned);
                                                                }}
                                                                placeholder="Enter Audible ASIN..."
                                                                disabled={loading}
                                                            />
                                                            <Button
                                                                variant="info"
                                                                className="ms-2 btn-sm"
                                                                disabled={!audibleAsinState}
                                                                onClick={async () => {
                                                                    try {
                                                                        const targetUrl = `${user?.user?.audible_country}/pd/${audibleAsinState}`;
                                                                        const response = await getRedirectUrlApi(targetUrl);
                                                                        if (response?.redirectUrl) {
                                                                            window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                        } else {
                                                                            console.error("Failed to get redirect URL");
                                                                        }
                                                                    } catch (err) {
                                                                        console.error("Redirect error:", err);
                                                                    }
                                                                }}
                                                            >
                                                                Check
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                )}
                                            </Col>
                                        )}

                                        {/* Если первая колонка есть → вторая md=6, иначе md=8 (как у тебя было) */}
                                        <Col md={newBook.paper_back_flag || newBook.kindle_flag ? 6 : 8} style={{ maxWidth: "100%" }}>
                                            {newBook.hard_cover_flag && (
                                                <Form className="mt-0 mb-0 p-1">
                                                    <div className="fw-semibold mb-0 text-muted">Hardcover ASIN:</div>
                                                    <div className="d-flex align-items-center">
                                                        <Form.Control
                                                            className="border border-secondary form-control-sm"
                                                            value={hardcoverAsinState}
                                                            onChange={(e) => {
                                                                const cleaned = e.target.value.replace(/\s/g, "").toUpperCase();
                                                                setHardCoverAsinState(cleaned);
                                                            }}
                                                            placeholder="Enter Hardcover ASIN..."
                                                            disabled={loading}
                                                        />
                                                        <Button
                                                            variant="info"
                                                            className="ms-2 btn-sm"
                                                            disabled={!hardcoverAsinState}
                                                            onClick={async () => {
                                                                try {
                                                                    const targetUrl = `${user?.user?.amz_country}/dp/${hardcoverAsinState}`;
                                                                    const response = await getRedirectUrlApi(targetUrl);
                                                                    if (response?.redirectUrl) {
                                                                        window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                    } else {
                                                                        console.error("Failed to get redirect URL");
                                                                    }
                                                                } catch (err) {
                                                                    console.error("Redirect error:", err);
                                                                }
                                                            }}
                                                        >
                                                            Check
                                                        </Button>
                                                    </div>
                                                </Form>
                                            )}

                                            {newBook.audio_flag && (
                                                <Form className="mt-0 mb-0 p-1">
                                                    <div className="fw-semibold mb-0 text-muted">Amazon Audio ASIN:</div>
                                                    <div className="d-flex align-items-center">
                                                        <Form.Control
                                                            className="border border-secondary form-control-sm"
                                                            value={audioAsinState}
                                                            onChange={(e) => {
                                                                const cleaned = e.target.value.replace(/\s/g, "").toUpperCase();
                                                                setAudioAsinState(cleaned);
                                                            }}
                                                            placeholder="Enter Amazon Audio ASIN..."
                                                            disabled={loading}
                                                        />
                                                        <Button
                                                            variant="info"
                                                            className="ms-2 btn-sm"
                                                            disabled={!audioAsinState}
                                                            onClick={async () => {
                                                                try {
                                                                    const targetUrl = `${user?.user?.amz_country}/dp/${audioAsinState}`;
                                                                    const response = await getRedirectUrlApi(targetUrl);
                                                                    if (response?.redirectUrl) {
                                                                        window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                    } else {
                                                                        console.error("Failed to get redirect URL");
                                                                    }
                                                                } catch (err) {
                                                                    console.error("Redirect error:", err);
                                                                }
                                                            }}
                                                        >
                                                            Check
                                                        </Button>
                                                    </div>
                                                </Form>
                                            )}
                                        </Col>

                                        {/* Non-Exclusive external audio link */}
                                        <Row>
                                            <Col className="p-0">
                                                {newBook.audio_non_exclusive_flag && (
                                                    <Form className="mt-2 mb-0 p-0 border-0">
                                                        <div className="fw-semibold mb-0 text-muted ms-3">
                                                            Enter Link to Your Non-Exclusive Audio Book:
                                                        </div>
                                                        <div className="d-flex align-items-between">
                                                            <Form.Control
                                                                className="border border-secondary ms-3 form-control-sm"
                                                                value={audioBookLinkState}
                                                                onChange={(e) => setAudioBookLinkState(e.target.value)}
                                                                placeholder="Enter Link to Your Non-Exclusive Audio Book... https://drive.google.com/drive/"
                                                                disabled={loading}
                                                            />
                                                            <Button
                                                                variant="info"
                                                                className="ms-2 btn-sm"
                                                                disabled={!audioBookLinkState}
                                                                onClick={() =>
                                                                    window.open(`${audioBookLinkState}`, "_blank", "noopener noreferrer")
                                                                }
                                                            >
                                                                Check
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                )}
                                            </Col>
                                        </Row>
                                    </Row>
                                </Card>

                                <Card className="mt-2 border border-secondary">
                                    <Card.Header className="py-2">
<span className="text-muted">
  Choose <b>Worldwide</b> if your book or product is available on all Amazon marketplaces.
  Otherwise, select the specific marketplaces where it is available.
</span>


                                    </Card.Header>
                                    <Card.Body>
                                        <Col xs={12} md={12}>
                                            <label className="d-block mb-0 text-muted fw-semibold">Available Marketplaces:</label>

                                            {/* ROW 1: Select (left) + Selected/Show-Hide (right) */}
                                            <div className="d-flex align-items-start gap-2">
                                                <Form.Select
                                                    size="sm"
                                                    className="border border-secondary text-muted"
                                                    value={territoriesMode}
                                                    onChange={(e) => {
                                                        const v = e.target.value;
                                                        setTerritoriesMode(v);

                                                        if (v === "WORLDWIDE") {
                                                            setAvailableMarketplaces([]);
                                                            setShowMarketplaces(false);
                                                        } else {
                                                            setShowMarketplaces(true);
                                                        }
                                                    }}
                                                    style={{ minWidth: 100, maxWidth: 200,  flex: "0 0 260px" }}
                                                >
                                                    <option value="WORLDWIDE">Worldwide</option>
                                                    <option value="MARKETPLACES">Custom marketplaces</option>
                                                </Form.Select>

                                                {territoriesMode === "MARKETPLACES" && (
                                                    <div className="d-flex align-items-center justify-content-between flex-grow-1">
                                                        <div className="small">
                                                            {availableMarketplaces.length === 0 ? (
                                                                <span className="text-danger fw-semibold">
              Pick at least one Amazon Marketplace
            </span>
                                                            ) : (
                                                                <span className="text-muted">

        Available on:{" "}
                                                                    {availableMarketplaces.map((code, index) => {
                                                                        const marketplace = MARKETPLACE_OPTIONS.find((m) => m.code === code);
                                                                        return (
                                                                            <React.Fragment key={code}>
                                                                                {index > 0 ? ", " : ""}
                                                                                {marketplace ? renderMarketplaceLink(marketplace, `.${code}`) : `.${code}`}
                                                                            </React.Fragment>
                                                                        );
                                                                    })}
                                                                    {" "}(<b>{availableMarketplaces.length}</b> total)
            </span>
                                                            )}
                                                        </div>

                                                        <Button
                                                            size="sm"
                                                            variant="outline-secondary"
                                                            onClick={() => setShowMarketplaces((s) => !s)}
                                                        >
                                                            {showMarketplaces ? "Hide" : "Show"}
                                                        </Button>
                                                    </div>
                                                )}
                                            </div>

                                            {/* ROW 2: checklist UNDER the dropdown */}
                                            {territoriesMode === "MARKETPLACES" && showMarketplaces && (
                                                <div className="mt-2 border rounded p-2">
                                                    <div
                                                        className="d-grid gap-1"
                                                        style={{
                                                            gridTemplateColumns: "repeat(2, minmax(160px, 1fr))",
                                                            maxHeight: 160,
                                                            overflowY: "auto",
                                                        }}
                                                    >
                                                        {MARKETPLACE_OPTIONS.map((m) => (
                                                            <Form.Check
                                                                key={m.code}
                                                                type="checkbox"
                                                                className="small text-muted mb-0"
                                                                label={renderMarketplaceLink(m)}
                                                                checked={availableMarketplaces.includes(m.code)}
                                                                onChange={(e) => {
                                                                    const checked = e.target.checked;
                                                                    setAvailableMarketplaces((prev) =>
                                                                        checked
                                                                            ? Array.from(new Set([...prev, m.code]))
                                                                            : prev.filter((x) => x !== m.code)
                                                                    );
                                                                }}
                                                            />
                                                        ))}
                                                    </div>

                                                    <div className="d-flex justify-content-end gap-2 mt-2">
                                                        <Button
                                                            size="sm"
                                                            variant="outline-secondary"
                                                            onClick={() => setAvailableMarketplaces([])}
                                                        >
                                                            Clear
                                                        </Button>

                                                        <Button
                                                            size="sm"
                                                            variant="success"
                                                            onClick={() => {
                                                                if (availableMarketplaces.length === 0) return;
                                                                setShowMarketplaces(false);
                                                            }}
                                                            disabled={availableMarketplaces.length === 0}
                                                            title={availableMarketplaces.length === 0 ? "Pick at least one marketplace" : ""}
                                                        >
                                                            Done
                                                        </Button>
                                                    </div>
                                                </div>
                                            )}
                                        </Col>
                                    </Card.Body>
                                </Card>
                                <Card className="mt-2">
                                    <Card.Body>
                                        <Row className="mb-2">
                                            <Col>
                                                <p className="text-start fw-semibold mb-0 text-muted">Edit Book Summary:</p>
                                                <Form.Control
                                                    className="p-2 border small rounded text-muted"
                                                    as="textarea"
                                                    rows={4}
                                                    value={summaryState}
                                                    onChange={e => setSummaryState(e.target.value)}
                                                    placeholder="Enter a short and meaningful summary for your book..."
                                                    style={{ fontSize: 14 }} // визуально приглушённый стиль
                                                />
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>



                                <Card className="mt-2 border border-secondary bg-secondary bg-opacity-10">
                                    <Card.Header className="py-1">
                                        <Form.Check
                                            type="checkbox"
                                            id="grab-public-catalog-visible"
                                            label={
                                                <span className="ms-1">
                                                    <span className="fw-semibold">I want to place my book in the public book library</span>
                                                    {publicCatalogVisible
                                                        ? " — Discoverable in the public ARC library."
                                                        : " — Your book won't be publicly listed."}
                                                </span>
                                            }
                                            checked={publicCatalogVisible}
                                            onChange={(e) => {
                                                const v = e.target.checked;
                                                setPublicCatalogVisible(v);
                                                saveBookDataToLocalStorage({ public_catalog_visible: v });
                                            }}
                                            className="custom-checkbox mt-2 me-2 mb-1"
                                        />
                                    </Card.Header>
                                </Card>

                                <Card className="mt-2 border border-secondary bg-secondary bg-opacity-10">
                                    <Card.Header className="py-1">
                                        <Form.Check
                                            type="checkbox"
                                            id="no-manuscript"
                                            label={
                                                <span className="ms-1">
      <span className="fw-semibold">I don’t want to upload the manuscript</span>
                                                    {" — Universal assignments will be unavailable."}
    </span>
                                            }
                                            checked={noManuscript}
                                            onChange={(e) => {
                                                const v = e.target.checked;
                                                setNoManuscript(v);
                                                saveBookDataToLocalStorage({ no_manuscript: v });
                                                if (v) {
                                                    // зачистим временное
                                                    setPdfFile(null);
                                                    setPdfFileTitle('');
                                                    setTempPDFFile('');
                                                    setUploadProgress(0);
                                                    localStorage.removeItem("temp_pdf_file");
                                                    localStorage.removeItem("pdf_file_title");
                                                    saveBookDataToLocalStorage({ temp_pdf_file: '', pdf_file_title: '' });
                                                }
                                            }}
                                            className="custom-checkbox mt-2 mb-1"
                                        />
                                    </Card.Header>
                                    {!noManuscript && (
                                        <Card.Body>
                                            <Row className="mb-2">
      <span className="mx-auto text-muted mb-3 text-start fw-semibold">
        Upload Your Book Manuscript File (PDF up to 500 Mb)
      </span>

                                                <div className="d-flex align-items-center mt-0 justify-content-between w-100">
                                                    {/* 🔴 Кнопка загрузки слева */}
                                                    <Button variant="danger" disabled={noManuscript} onClick={triggerFileInputBook} className="me-3 btn btn-sm">
                                                        Upload File
                                                    </Button>

                                                    {/* 🔹 Индикатор загрузки справа */}
                                                    {uploadProgress > 0 && (
                                                        <div
                                                            className="progress flex-grow-1"
                                                            role="progressbar"
                                                            aria-valuenow={uploadProgress}
                                                            aria-valuemin="0"
                                                            aria-valuemax="90"
                                                            style={{ height: "30px" }} // Увеличенная высота
                                                        >
                                                            <div
                                                                className={`progress-bar ${uploadProgress === 100 ? "bg-success" : "bg-info"}`}
                                                                style={{ width: `${uploadProgress}%` }}
                                                            >
                                                                {uploadProgress === 100
                                                                    ? (
                                                                        <span className="fw-semibold fst-normal">
                                                                     Uploading {pdfFileTitle.length > 90
                                                                            ? pdfFileTitle.slice(0, 90) + '...'
                                                                            : pdfFileTitle
                                                                        } is Complete!
                                                                   </span>
                                                                    )
                                                                    : uploadProgress === 99
                                                                        ? <span className="fw-semibold fst-normal">Processing manuscript: watermarking and compressing...</span>
                                                                        : `${uploadProgress}%`
                                                            }
                                                            </div>
                                                        </div>
                                                    )}
                                                    {(pdfFileTitle && !uploadProgress) && (
                                                        <>
                                                            <Col className="text-center shadow-sm rounded-1 border border-secondary py-1 small">
                                                                <strong className="text-muted d-block">Uploaded: {pdfFileTitle}</strong>
                                                            </Col>
                                                        </>
                                                    )}
                                                    {(uploadProgress !== 100 && !pdfFileTitle) && (
                                                        <Col className="text-center shadow-sm rounded-1 border border-secondary py-1 small">
                                                            <strong className="text-muted d-block">Press "Upload File" to begin uploading.</strong>
                                                        </Col>
                                                    )}


                                                </div>

                                                {/* 🔹 Скрытый input для загрузки */}
                                                <Form.Group className="mb-0">
                                                    <Form.Control
                                                        type="file"
                                                        accept="application/pdf"
                                                        id="fileInputBook"
                                                        onChange={selectBookFile}
                                                        style={{ display: "none" }}
                                                    />
                                                </Form.Group>

                                                {/* Инструкция */}
                                                <div className="d-flex justify-content-end">
                                                    <p className="mb-0 text-muted small fst-italic text-end">
                                                        {uploadProgress > 0 && uploadProgress < 100
                                                            ? "Processing manuscript: watermarking and compressing. Please wait..."
                                                            : uploadProgress !== 100 && !pdfFileTitle
                                                            ? "After uploading your book file, you'll be able to submit it for moderation."
                                                            : "Click Submit for Moderation to send it to moderation."}
                                                    </p>
                                                </div>
                                            </Row>
                                        </Card.Body>
                                        )}

                                </Card>


                            </Col>
                        </Row>
                        <Row>
                            <div className="d-flex justify-content-end mt-0">
                                <Button variant="success"
                                        type="button"
                                        className="btn btn-sm"
                                        onClick={handleSubmitBookToModeration}
                                        disabled={loading || manuscriptUploadInProgress || !manuscriptRequirementSatisfied}>
                                    {loading ? (
                                        <>
                                            Sending Book Data&nbsp;
                                            <Spinner animation="border" size="sm" />
                                        </>
                                    ) : uploadProgress > 0 && uploadProgress < 100 ? (
                                        <>
                                            {uploadProgress === 99 ? "Processing Manuscript" : "Uploading Your File"}&nbsp;
                                            <Spinner animation="border" size="sm" />
                                        </>
                                    ) : !manuscriptRequirementSatisfied ? (
                                        'Upload Manuscript Please'
                                    ) : (
                                        'Submit for Moderation'
                                    )}


                                </Button>
                            </div>
                        </Row>


                    </Form>
                )}
                <CacheUpdateModalBook />
            </Card>
        </>
    );

});

export default AddBookByGrabFromAmazon;
